import { useEffect } from "react";

const APP_NAME = "Centro Monitoreo Hikdos";

/** Names the browser tab so an operator can keep several views open at once. */
export function useDocumentTitle(title?: string | null): void {
  useEffect(() => {
    document.title = title ? `${title} · ${APP_NAME}` : `${APP_NAME} | Monitoreo operativo`;
  }, [title]);
}
